import React, { useEffect } from "react";
import useMedia from "../componentsofcourse/useMedia";
import HeroImg from "../Assets/img/Home/hero_img.png";
import HeroText from "../Assets/img/Home/hero_text.png";
import { Link } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
const HeroSection = () => {
	useEffect(() => {
		AOS.init();
	});
	const matches = useMedia("(min-width : 768px )");
	const video =
		"https://cantileverlabs-video-bucket.s3.ap-south-1.amazonaws.com/3.mp4";
	return (
		<div>
			{matches ? (
				<div className="container ">
					<br />
					<div className="row">
						<div
							className="col-lg-5 col-xl-5 col-sm-5 col-md-5"
							style={{ marginBottom: "0px" }}
						>
							<div
								style={{ marginTop: "55%", textAlign: "left" }}
							>
								<h2 data-aos="zoom-out-right">
									UPSKILL for Future <br />
									Grab your dream job
								</h2>
								<br />
								<Link
									style={{
										borderRadius: "40px",
										padding: "12px",
										width: "60%",
										fontSize: "20px",
									}}
									to="MOVEHERE"
									className=" btn btn-warning text-white"
								>
									Explore Courses
								</Link>
							</div>
						</div>
						<div
							className="col-lg-7 col-xl-7 col-sm-7 col-md-7"
							style={{
								display: "flex",
								justifyContent: "center",
								marginBottom: "0px",
								marginTop: "10%",
							}}
						>
							{/*  <img src={HeroImg} width="97%" alt="" /> */}
							<video
								className="col-lg-7 col-xl-7 col-sm-7 col-md-7"
								loop
								muted
								autoPlay
							>
								<source src={video} type="video/mp4" />
							</video>
						</div>
					</div>
				</div>
			) : (
				<div className="container ">
					<div className="row">
						<div
							className="col-lg-6 col-xl-6 col-sm-12 col-md-12"
							style={{
								display: "flex",
								justifyContent: "center",
								marginBottom: "0px",
								marginTop: "25%",
								zIndex: "-2",
							}}
						>
							{/* <img
                style={{ marginTop: "15%" }}
                src={HeroImg}
                width="80%"
                alt=""
              /> */}
							<video
								className="col-lg-6 col-xl-6 col-sm-12 col-md-12"
								style={{ width: "60%" }}
								loop
								muted
								autoPlay
							>
								<source src={video} type="video/mp4" />
							</video>
						</div>
						<div className="col-lg-6 col-xl-6 col-sm-12 col-md-12">
							<div>
								<h2>
									UPSKILL for Future <br />
									Grab your dream job
								</h2>
								<br />
								<Link
									style={{
										padding: "10px",
										width: "100%",
										fontSize: "20px",
									}}
									to="MOBILEMOVE"
									ignoreCancelEvents={true}
									className=" btn btn-warning text-white"
									duration={1000}
									onClick={() => {
										setTimeout(() => {
											//x = window.scrollY -5
											// y = window.scrollX
											window.scrollBy({
												top: -85,
												behavior: "smooth",
											});
										}, 900);
									}}
								>
									Explore Courses
								</Link>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
export default HeroSection;
